import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

type RunStatusInfoProps = {
  id: string,
  date: Date | string,
  hasRun: boolean,
}

export const RunStatusInfo = ({
  id,
  date,
  hasRun,
}:RunStatusInfoProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <Typography
        variant={ style.boxInfo.typography.variant }
        color={ style.typography.sx }
      >
        {translate(STRING_KEYS.ENGINE_RUNS)}
      </Typography>
      {hasRun && (
        <Typography
          variant={ style.boxLastRun.typography.variant }
          sx={ style.typography.sx }
        >
          {translate(STRING_KEYS.LAST_RUN, { id, date })}
        </Typography>
      )}
    </Box>
  );
};
